export default __webpack_public_path__ + "static/media/Selesaikan Pemesanan.59fc71e5.svg";